export default __webpack_public_path__ + "assets/images/fde6f60b69aa4e959426f0f1fe974bcc.png";